import { render, staticRenderFns } from "./MyCkEditorDialog.vue?vue&type=template&id=506265ac&"
import script from "./MyCkEditorDialog.vue?vue&type=script&lang=js&"
export * from "./MyCkEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506265ac')) {
      api.createRecord('506265ac', component.options)
    } else {
      api.reload('506265ac', component.options)
    }
    module.hot.accept("./MyCkEditorDialog.vue?vue&type=template&id=506265ac&", function () {
      api.rerender('506265ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyCkEditorDialog.vue"
export default component.exports